import styled from "styled-components";
import { MEDIA_QUERY } from "../../entities/Common";

export const MixtureTabStyled = styled.div<{$border?:string}>`
  border: ${({ $border }) => ($border ? $border : "2px solid #fdca31")};
  background: #fff 0 0 no-repeat padding-box;
  box-shadow: 0 3px 20px #00000029;
  padding: 20px;
  box-sizing: border-box;
  width: 500px;
  margin-left: 20px;
  .mixture-table {
    &__title {
      width: 100%;
      text-align: center;
      margin-bottom: 0px;
    }
  }
  .buttons-flex {
    margin-top: 30px;
    margin-bottom: 20px;
  }

  @media (max-width: ${MEDIA_QUERY.LAPTOP}) {
    position: sticky;
    left: 0px;
    bottom: 0;
    width: calc(100vw - 40px);
    margin: 0 auto;
    z-index: 10;
    border: none;
    &[data-length="0"] {
      display: none;
    }
    .buttons-flex {
      max-width: 500px;
      margin: 0 auto;
    }
  }
`;

export const MixtureTabItemsStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-end;
  margin-top: 20px;
  > div {
    margin-bottom: 10px;
  }

  @media (max-width: ${MEDIA_QUERY.TABLET_HORIZONTAL}) {
    flex-wrap: nowrap;
    justify-content: flex-start;
    overflow-x: scroll;
  }
`;
